import { Controller } from "@hotwired/stimulus"

/**
 * Autorisations de sortie — section accompagnateur.
 * Deux modes : « Parent(s) » (cases à cocher des parents de l'élève
 * sélectionné, rechargées quand l'élève change) ou « Autre accompagnateur »
 * (champs libres nom/téléphone). Basculer vide les valeurs de l'autre mode.
 */
export default class extends Controller {
  static targets = [
    "studentSelect",
    "kindRadio",
    "parentBlock",
    "parentList",
    "parentCheckbox",
    "otherBlock",
    "companionName",
    "companionPhone",
  ]

  static values = {
    parentsUrl: String,
    noParentsText: String,
    selectStudentText: String,
  }

  get kind() {
    const checked = this.kindRadioTargets.find((r) => r.checked)
    return checked ? checked.value : "parent"
  }

  kindChanged() {
    const parentMode = this.kind === "parent"
    this.parentBlockTarget.classList.toggle("hidden", !parentMode)
    this.otherBlockTarget.classList.toggle("hidden", parentMode)

    // Vider les valeurs du mode inactif pour que la soumission soit cohérente
    if (parentMode) {
      if (this.hasCompanionNameTarget) this.companionNameTarget.value = ""
      if (this.hasCompanionPhoneTarget) this.companionPhoneTarget.value = ""
    } else {
      this.parentCheckboxTargets.forEach((cb) => { cb.checked = false })
    }
  }

  // Recharge la liste des parents quand l'élève change
  studentChanged() {
    const studentId = this.studentSelectTarget.value
    if (!studentId) {
      this.renderMessage(this.selectStudentTextValue)
      return
    }

    const url = `${this.parentsUrlValue}?student_id=${encodeURIComponent(studentId)}`
    fetch(url, { headers: { Accept: "application/json" } })
      .then((response) => response.json())
      .then((parents) => this.renderParents(parents))
      .catch(() => this.renderMessage(this.noParentsTextValue))
  }

  renderParents(parents) {
    if (!parents.length) {
      this.renderMessage(this.noParentsTextValue)
      return
    }

    this.parentListTarget.innerHTML = ""
    parents.forEach((parent) => {
      const label = document.createElement("label")
      label.className = "ds-export__opt"

      const check = document.createElement("span")
      check.className = "ds-check"

      const input = document.createElement("input")
      input.type = "checkbox"
      input.name = "exit_authorization[parent_ids][]"
      input.value = parent.id
      input.id = `exit_authorization_parent_ids_${parent.id}`
      input.dataset.companionFormTarget = "parentCheckbox"

      const box = document.createElement("span")
      box.className = "ds-check__box"
      box.innerHTML = this.checkIconHTML()

      check.append(input, box)

      const text = document.createElement("span")
      text.textContent = parent.full_name
      if (parent.phone) {
        const phone = document.createElement("span")
        phone.className = "ds-recentrow__detail"
        phone.textContent = ` (${parent.phone})`
        text.appendChild(phone)
      }

      label.append(check, text)
      this.parentListTarget.appendChild(label)
    })
  }

  renderMessage(message) {
    this.parentListTarget.innerHTML = ""
    const p = document.createElement("p")
    p.className = "ds-recentrow__detail"
    p.textContent = message
    this.parentListTarget.appendChild(p)
  }

  // Réutilise l'icône de coche déjà rendue dans la page (cases des motifs),
  // pour rester aligné sur le rendu serveur de shared/ds/icon.
  checkIconHTML() {
    const existing = this.element.closest("form")?.querySelector(".ds-check__box svg")
    return existing ? existing.outerHTML : "✓"
  }
}
